// BuzzBump Chatbot - Knowledge Base (100% local, no API)
// Each intent has: id, keywords (FR), patterns (variations), answers, related (related question IDs)

export const chatbotIntents = [
  {
    id: 'greeting',
    keywords: ['bonjour', 'salut', 'hello', 'coucou', 'hey', 'hi', 'bonsoir', 'yo'],
    patterns: ['bonjour', 'salut', 'hello'],
    answers: [
      "Salut ! 🐝 Je suis l'assistant BuzzBump. Comment puis-je t'aider aujourd'hui ?",
      "Bonjour ! Bienvenue dans la ruche BuzzBump. Pose-moi une question sur l'application !",
    ],
    related: ['what_is', 'how_play', 'download'],
  },
  {
    id: 'thanks',
    keywords: ['merci', 'thanks', 'thx', 'super', 'génial', 'parfait', 'cool'],
    patterns: ['merci', 'thanks'],
    answers: [
      "Avec plaisir ! 🐝 N'hésite pas si tu as d'autres questions.",
      "De rien ! Je suis là pour t'aider à découvrir BuzzBump.",
    ],
    related: ['contact', 'help_project'],
  },
  {
    id: 'bye',
    keywords: ['au revoir', 'bye', 'a plus', 'à plus', 'ciao', 'adieu', 'see you'],
    patterns: ['bye'],
    answers: [
      "À bientôt dans la ruche ! 🐝",
      "À très vite sur BuzzBump !",
    ],
    related: [],
  },
  {
    id: 'what_is',
    keywords: ["c'est quoi", 'qu\'est', 'qu est', 'quoi', 'définition', 'présenter', 'présentation', 'concept', 'buzzbump', 'buzz bump', 'app', 'application'],
    patterns: ["c'est quoi buzzbump", "qu'est ce que buzzbump", "présente moi"],
    answers: [
      "BuzzBump est une application mobile novatrice qui combine **défis urbains interactifs**, **messagerie dynamique** et **carte des scores** pour vivre des expériences sociales et ludiques uniques. L'idée : défier tes amis (ou des inconnus) dans la vraie vie, marquer des points et grimper au classement !",
    ],
    related: ['how_play', 'modes', 'map', 'messaging'],
  },
  {
    id: 'how_play',
    keywords: ['comment jouer', 'comment ça marche', 'fonctionne', 'utiliser', 'gameplay', 'défier', 'défi', 'défis', 'jouer', 'joue', 'principe'],
    patterns: ['comment jouer', 'comment ça marche', 'comment ça fonctionne'],
    answers: [
      "C'est simple ! 🎯\n\n1. Tu lances un **défi** (une « crasse ») à un ami ou à un joueur proche via la **Map**\n2. L'adversaire reçoit une notification et choisit à son tour un défi à te lancer\n3. **Le premier qui réussit sa crasse l'emporte** et empoche tous les points !\n4. Tu grimpes dans le classement et débloques des récompenses",
    ],
    related: ['modes', 'classement', 'map', 'crasse'],
  },
  {
    id: 'modes',
    keywords: ['mode', 'modes', 'mode de jeu', 'âge', 'mineur', 'majeur', '18 ans', 'moins de 18', 'plus de 18', 'enfant', 'adulte'],
    patterns: ['quels sont les modes', 'mode de jeu'],
    answers: [
      "BuzzBump propose **2 modes de jeu** adaptés selon l'âge :\n\n🔹 **Mode -18 ans** : crasses aléatoires prédéfinies par notre équipe pour garantir une expérience saine. Les profils majeurs n'apparaissent pas sur la map.\n\n🔹 **Mode +18 ans** : les joueurs créent eux-mêmes leurs crasses. Plus de liberté, mais cloisonné des mineurs.\n\nLes deux mondes sont totalement séparés pour la sécurité de tous.",
    ],
    related: ['security', 'how_play', 'map'],
  },
  {
    id: 'classement',
    keywords: ['classement', 'leaderboard', 'rang', 'rangs', 'points', 'score', 'scores', 'récompense', 'récompenses', 'gagner', 'remporter'],
    patterns: ['comment fonctionne le classement', 'points'],
    answers: [
      "🏆 Plus ta crasse est **audacieuse**, plus elle rapporte de points (à condition de réussir sans te faire démasquer !).\n\nPlus tu accumules de points, plus tu grimpes dans le classement. Les joueurs au sommet débloquent des **récompenses exclusives**. Seuls les plus sadiques et vicieux terminent en haut !",
    ],
    related: ['how_play', 'modes', 'crasse'],
  },
  {
    id: 'crasse',
    keywords: ['crasse', 'crasses', 'blague', 'piège', 'défi', 'challenge'],
    patterns: ['qu\'est-ce qu\'une crasse'],
    answers: [
      "Une **crasse** est un défi/piège que tu lances à un autre joueur. Ça peut être une farce, une mission rigolote, un challenge à réaliser dans la vraie vie. Plus c'est cruel (et plus tu réussis sans te faire démasquer), plus tu marques de points !",
    ],
    related: ['classement', 'how_play', 'modes'],
  },
  {
    id: 'map',
    keywords: ['map', 'carte', 'géolocalisation', 'gps', 'position', 'proximité', 'localiser', 'voir les joueurs'],
    patterns: ['comment fonctionne la map', 'la carte'],
    answers: [
      "🗺️ La **Map dynamique** affiche en temps réel la position des autres joueurs autour de toi. Tu peux sélectionner un joueur à proximité, voir son profil, et lui lancer un défi directement. Le premier qui réussit sa crasse à l'autre l'emporte !",
    ],
    related: ['how_play', 'security', 'modes'],
  },
  {
    id: 'messaging',
    keywords: ['messagerie', 'message', 'chat', 'discuter', 'parler', 'discussion', 'écrire', 'conversation'],
    patterns: ['comment marche la messagerie', 'chat'],
    answers: [
      "💬 La **messagerie instantanée** est inspirée des meilleures messageries actuelles. Elle te permet d'échanger avec amis et inconnus, de provoquer tes adversaires avant de leur tendre un piège, et de faire de nouvelles rencontres. Idéal pour les vrais sadiques 😈",
    ],
    related: ['social', 'how_play', 'map'],
  },
  {
    id: 'social',
    keywords: ['réseau social', 'social', 'caméra', 'camera', 'filmer', 'vidéo', 'poster', 'partage', 'partager', 'feed'],
    patterns: ['réseau social', 'caméra intégrée'],
    answers: [
      "📸 BuzzBump intègre un **réseau social interne** ! Filme tes meilleures crasses grâce à l'icône caméra, puis poste-les pour la communauté. Tu peux aussi regarder les exploits des autres joueurs et profiter d'un feed dédié 100% fun.",
    ],
    related: ['messaging', 'communaute'],
  },
  {
    id: 'communaute',
    keywords: ['communauté', 'communaute', 'communautée', 'joueurs', 'membres', 'rejoindre', 'ruche'],
    patterns: ['la communauté'],
    answers: [
      "🐝 Rejoins une **communauté active et engagée** prête à relever tous les défis. C'est la ruche ! Plus on est nombreux, plus on s'amuse. Tu peux suivre les exploits des autres et partager les tiens.",
    ],
    related: ['social', 'help_project', 'download'],
  },
  {
    id: 'download',
    keywords: ['télécharger', 'download', 'installer', 'app store', 'play store', 'apk', 'ios', 'android', 'disponible', 'sortie'],
    patterns: ['où télécharger', 'comment installer'],
    answers: [
      "📲 L'application est en cours de finalisation ! Pour être notifié dès la sortie, rends-toi sur la page **Nous contacter** ou inscris-toi à la newsletter dans **Nous aider**. Tu auras un accès anticipé à la bêta si tu nous soutiens !",
    ],
    related: ['help_project', 'contact', 'beta'],
  },
  {
    id: 'beta',
    keywords: ['beta', 'bêta', 'accès anticipé', 'tester', 'testeur', 'avant-première'],
    patterns: ['accès bêta', 'devenir testeur'],
    answers: [
      "🚀 Tu peux obtenir un **accès anticipé à la bêta** en soutenant le projet via la page **Nous aider** (niveau Ruche ou Reine). Tu seras parmi les premiers à découvrir BuzzBump !",
    ],
    related: ['help_project', 'tarifs', 'download'],
  },
  {
    id: 'price',
    keywords: ['prix', 'coût', 'cout', 'payant', 'gratuit', 'tarif', 'tarifs', 'combien', 'cher'],
    patterns: ["c'est gratuit", 'combien ça coûte'],
    answers: [
      "🆓 L'application **BuzzBump sera gratuite** au lancement, avec des fonctionnalités premium optionnelles. Si tu veux nous soutenir, des paliers de soutien sont disponibles (Abeille 5€, Ruche 25€, Reine 100€) via Ko-fi.",
    ],
    related: ['help_project', 'tarifs', 'download'],
  },
  {
    id: 'tarifs',
    keywords: ['soutien', 'soutenir', 'palier', 'paliers', 'ko-fi', 'kofi', 'donation', 'donner', 'abeille', 'ruche', 'reine'],
    patterns: ['paliers de soutien'],
    answers: [
      "💛 Trois niveaux de soutien sont proposés via **Ko-fi** :\n\n🐝 **Abeille (5€)** : mention, Discord privé, newsletter exclusive\n🍯 **Ruche (25€)** : tout l'Abeille + accès anticipé à la bêta + badge collector + goodies\n👑 **Reine (100€)** : tout la Ruche + nom dans les crédits + skin de profil exclusif + rencontre avec l'équipe",
    ],
    related: ['help_project', 'beta', 'price'],
  },
  {
    id: 'help_project',
    keywords: ['aider', 'soutenir le projet', 'contribuer', 'don', 'donation', 'financer', 'investir'],
    patterns: ['comment aider', 'comment soutenir'],
    answers: [
      "Tu peux nous aider de plusieurs façons : 🐝\n\n• **Partage** BuzzBump sur tes réseaux\n• **Donne ton avis** pour améliorer l'app\n• **Soutiens financièrement** via Ko-fi pour accélérer le développement\n\nRends-toi sur la page **Nous aider** pour voir tous les détails !",
    ],
    related: ['tarifs', 'beta', 'contact'],
  },
  {
    id: 'contact',
    keywords: ['contact', 'contacter', 'mail', 'email', 'instagram', 'tiktok', 'réseaux', 'joindre'],
    patterns: ['comment vous contacter'],
    answers: [
      "📬 Tu peux nous joindre via :\n\n• **Email PRO** : contact.buzzbump@gmail.com\n• **Instagram** : @buzz_bump\n• **TikTok** : @buzzbump\n• Le formulaire sur la page **Nous contacter**",
    ],
    related: ['team', 'help_project'],
  },
  {
    id: 'team',
    keywords: ['équipe', 'qui', 'derrière', 'créateur', 'fondateur', 'développeur', 'à propos', 'a propos'],
    patterns: ["qui êtes-vous", 'qui est derrière'],
    answers: [
      "🐝 BuzzBump est porté par une équipe passionnée basée en France. Tout a commencé par une soirée entre amis, un défi spontané, et l'envie de transformer ce fun en application mobile. Nos valeurs : **Innovation, Communauté, Fun, Sécurité**. Découvre-nous sur la page **À propos**.",
    ],
    related: ['contact', 'help_project'],
  },
  {
    id: 'security',
    keywords: ['sécurité', 'securite', 'safe', 'protection', 'enfant', 'mineur', 'données', 'vie privée', 'privacy', 'abus'],
    patterns: ['sécurité des mineurs', 'protection des données'],
    answers: [
      "🛡️ La **sécurité** est un pilier de BuzzBump. Le mode -18 ans propose uniquement des crasses pré-validées par notre équipe, et les profils majeurs n'apparaissent jamais sur leur map. L'environnement reste sain, bienveillant et fun pour tous.",
    ],
    related: ['modes', 'team'],
  },
  {
    id: 'platform',
    keywords: ['ios', 'android', 'iphone', 'apple', 'samsung', 'plateforme', 'compatible'],
    patterns: ['compatible iphone', 'sur android'],
    answers: [
      "📱 BuzzBump sera disponible sur **iOS et Android** au lancement. Inscris-toi pour être notifié dès la sortie !",
    ],
    related: ['download', 'beta'],
  },
  {
    id: 'when_release',
    keywords: ['quand', 'date', 'sortie', 'lancement', 'release', 'sortir', 'disponible'],
    patterns: ['quand sortira', 'date de sortie'],
    answers: [
      "📅 La date de lancement officielle sera annoncée prochainement ! En attendant, inscris-toi à la newsletter pour être prévenu en avant-première, ou soutiens-nous pour accéder à la bêta.",
    ],
    related: ['beta', 'help_project', 'contact'],
  },
];

// Suggestions affichées au démarrage
export const starterQuestions = [
  { id: 'what_is', label: "C'est quoi BuzzBump ?" },
  { id: 'how_play', label: 'Comment jouer ?' },
  { id: 'modes', label: 'Quels modes de jeu ?' },
  { id: 'price', label: "C'est gratuit ?" },
  { id: 'download', label: 'Où télécharger ?' },
  { id: 'help_project', label: 'Comment soutenir ?' },
];

// Map ID -> label pour suggestions liées
export const intentLabels = {
  what_is: "C'est quoi BuzzBump ?",
  how_play: 'Comment jouer ?',
  modes: 'Modes de jeu',
  classement: 'Le classement',
  crasse: "Qu'est-ce qu'une crasse ?",
  map: 'La Map dynamique',
  messaging: 'La messagerie',
  social: 'Réseau social',
  communaute: 'La communauté',
  download: 'Télécharger',
  beta: 'Accès bêta',
  price: 'Prix',
  tarifs: 'Paliers de soutien',
  help_project: 'Comment aider ?',
  contact: 'Nous contacter',
  team: "L'équipe",
  security: 'Sécurité',
  platform: 'Plateformes',
  when_release: 'Date de sortie',
};
